import axios from 'axios';

export default function performTracking(urls) {
  if (urls?.length) {
    urls.forEach(axios.get);
  }
}
